import React from 'react';
import PropTypes from 'prop-types';
import MarkdownElement from '@material-ui/docs/MarkdownElement';
import { withStyles } from '@material-ui/core/styles';
import VdeDatasetViewerDownloadsTable from './vdeDatasetViewerDownloadsTable.js';
/* eslint import/no-webpack-loader-syntax: off */
import vdeDatasetViewerPre from '!raw-loader!./vdeDatasetViewerPre.md';
import vdeDatasetViewerPost from '!raw-loader!./vdeDatasetViewerPost.md';

const styles = theme => ({
    root: {
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
    },
});

function VdeDatasetViewerDownloads(props) {
    const { classes } = props;

    return (
        <div className={classes.root}>
            <MarkdownElement text={vdeDatasetViewerPre} />
            <VdeDatasetViewerDownloadsTable currentVersion={props.currentVersion} />
            <MarkdownElement text={vdeDatasetViewerPost} />
        </div>
    );
}

VdeDatasetViewerDownloads.propTypes = {
    classes: PropTypes.object.isRequired,
    currentVersion: PropTypes.string.isRequired,
};

export default withStyles(styles)(VdeDatasetViewerDownloads);